import MuiDialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';

type Props = DialogTitleProps & {
  padding?: number;
};

export const DialogTitle = ({ children, padding = 3, ...props }: Props) => {
  return (
    <MuiDialogTitle
      {...props}
      sx={{
        paddingX: padding,
      }}
    >
      {children}
    </MuiDialogTitle>
  );
};
